/* One observer, safe with editor section reloads and repeated asset tags. */
(() => {
  if (window.infinoteHomeLoaded) return;
  window.infinoteHomeLoaded = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      if (!motion.matches) target.classList.add('is-entering');
      observer.unobserve(target);
    });
  }, { threshold: 0.1 });
  function init(root) {
    root.querySelectorAll('[data-inf-reveal]').forEach(element => observer.observe(element));
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
